import "../../../../../node_modules/react-toastify/dist/ReactToastify.css";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Await, useNavigate } from "react-router-dom";
import { fetchTransactionList } from "../../../../Redux/Actions/fetchTransactionList";
import DataTable from "../../../Layouts/Data-Table/DataTable";
import download from "../../../../Assets/Images/download.svg";
import merge from "../../../../Assets/Images/Vector.svg";
import "./PolicyCard.css";
import { exportPDF, getBase64, exportPdfPageOne, exportPdfPageTwo, base64ToUint8Array } from "../../../../utils/commonUtils";
import { exportInvoicePDF } from "../../../../utils/invoicePdf";
import edit from "../../../../Assets/Images/edit-table.svg";
import mergeDownlaod from "../../../../Assets/Images/pureWhiteArrowIcon.png"
import pdfToText from 'react-pdftotext';
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../Layouts/Loader/Loader";
import { PDFDocument } from 'pdf-lib';
import { Buffer } from "buffer";
import Modal from "react-modal";
import InputFields from "../../../InputField/TextField/InputField";
import Button from "../../../InputField/Button/Button";
import { decryptPdfAction } from "../../../../Redux/Actions/decryptpdfAction";
import { sendEmail } from "../../../../Redux/Actions/SendEmail";
import { mergepdfAction } from "../../../../Redux/Actions/mergepdfAction";

import moment from "moment-timezone";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};


const NoPoliciesFound = (props) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  let policyTypeList = [
    { value: "Comprehensive", label: "Comprehensive" },
    { value: "Third Party", label: "Third Party" },
    { value: "Bundled (3Y TP + 1Y OD)", label: "Bundled" },
  ];

  const handleHomePage = () => {
    navigate("/View-Plans");
  };

  // userToken
  const userToken = useSelector((state) => {
    return state?.getLoggedInStatus?.data?.loginData?.token;
  });
  let getTransactionListTotalCount = useSelector((state) => {
    return state?.getTransactionList?.data?.data;
  });
  const getclientMobileData = useSelector((state) => {
    return state?.getLoggedInStatus?.data?.loginData?.mobile;
  })


  let getTransactionList = useSelector((state) => {
    return state?.getTransactionList?.data?.data?.transaction;
  });



  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [newLoder, setNewLoadi] = useState(false);
  const [errors, setErrors] = useState({});
  const [odFile, setOdFile] = useState(null);
  const [tpFile, setTpFile] = useState(null);
  const [TransactionData, setTransactionData] = useState(null);
  const [ShowValidateBtn, setShowValidateBtn] = useState(true);
  const [filterText, setFilterText] = React.useState("");
  const [searachQuery, setSerachQuery] = React.useState("")
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [serchQueryFlg, setSearchQueryFlag] = useState(false)
  const [page, setPage] = React.useState(0);
  const [FormData, setFormData] = useState({
    netPremium: null,
    gst: null,
    totalPremium: null,
  })


  async function getTransactionListData() {
    let bodyData = {
      userToken: userToken,
      pageNumber: page + 1,
      serachValue: searachQuery,
      pagelimit: rowsPerPage
    }
    let data = await dispatch(fetchTransactionList(bodyData));


  };
  useEffect(() => {
    setNewLoadi(true)
    getTransactionListData().then((data) => {
      setNewLoadi(false)
    }).catch((err) => {
      setLoading(false)
    })
  }, [page, serchQueryFlg]);



  useEffect(() => {
    if (FormData.netPremium !== null, FormData.gst !== null, FormData.totalPremium !== null) {
      setShowValidateBtn(false)
    }
  }, [FormData])

  function openModal(data) {
    setIsOpen(true);
    setTransactionData(data);
    setErrors({})
  }

  function closeModal() {
    setIsOpen(false);
    setFormData((prevItems) => ({
      ...prevItems,
      netPremium: null,
      gst: null,
      totalPremium: null,
    }))
  }


  const validatePremiumDetails = () => {
    const newErrors = {};

    if (!FormData.gst) {
      newErrors.gst = "GST is required";
    }
    if (!FormData.totalPremium) {
      newErrors.totalPremium = "Total Premium is required";
    }
    if (!FormData.netPremium) {
      newErrors.netPremium = "Net Premium is required";
    }
    // if (!odFile && !tpFile && getclientMobileData=="8329832422") {
    //   newErrors.tpFile = "Please Upload policy pdf"
    // }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // Function to extract value based on pattern
  function extractValue(text, pattern, matchNo = 1) {
    const match = pattern.exec(text);
    return match ? (matchNo == 1 ? match[1] : match[2]) : null;
  }

  const extractTextIsOptGst = async (event, data) => {

    // alert("kakak")


    setLoading(true);
    const file = event.target.files[0]
    setShowValidateBtn(true);
    closeModal();
    let packagePremium = parseFloat(data?.netPremium) ? parseFloat(data?.netPremium) : "0";
    let igst = parseFloat(data?.gst) ? parseFloat(data?.gst) : "0";
    let totalPremium = parseFloat(data?.totalPremium) ? parseFloat(data?.totalPremium) : "0";
    // pdfToText(file)
    //   .then(async (text) => {

    let companyName = data?.proposal_body?.companyName ? data?.proposal_body?.companyName : "ACKO"
    // let regexTotalPremium = '';
    // let regexSGST = '';
    // let regexCGST = '';
    // let regexPackage = '';

    // switch (companyName) {
    //   case "ACKO":
    //     regexTotalPremium = /Total Premium\s+\s+([\d,.]+)/;
    //     regexSGST = /IGST\s+\(18%\)\s+([\d,.]+)/;
    //     regexCGST = /NOTAVAILABLE/;
    //     regexPackage = /Total Package Premium \(A\+B\)      ([0-9,]+)\.00 IGST/;
    //     break;
    //   case "UNITED":
    //     regexTotalPremium = /TOTAL PAYABLE PREMIUM\s*([\d.,]+)/;
    //     regexSGST = /IGST\(18%\)\s*([\d.,]+)/;
    //     regexCGST = /NOTAVAILABLE/;
    //     regexPackage = /Premium\(A\+B\)\s*([\d.,]+)/;
    //     break;
    //   case "TATA":
    //     regexPackage = /Net Premium \(A\+B\+C\) \s* ₹ \s*([\d,]+\.\d{2})/;
    //     regexSGST = /UGST\/SGST @9 %\s+₹\s+([^ ]+)/;
    //     regexCGST = /CGST @9 %\s+₹\s+([^ ]+)/;
    //     regexTotalPremium = /Total Policy Premium \s*([\d,]+\.\d{2})/;
    //     break;
    //   case "BAJAJ":
    //     regexPackage = /Total Premium \(Net Premium\) \(A\+B\)\s*([\d,]+\.\d{2})/;
    //     regexSGST = /State GST \(9%\)\s*([\d,]+\.\d{2})/;
    //     regexCGST = /Central GST \(9%\)\s*([\d,]+\.\d{2})/;
    //     regexTotalPremium = /Final Premium \( Rupees (.*) Only \)\s*([\d,]+\.\d{2})/;
    //     break;
    //   default:
    //     regexTotalPremium = /Total Premium\s+\s+([\d,.]+)/;
    //     regexSGST = /IGST\s+\(18%\)\s+([\d,.]+)/;
    //     regexCGST = /NOTAVAILABLE/;
    //     regexPackage = /Total Package Premium \(A\+B\)      ([0-9,]+)\.00 IGST/;
    //     break;
    // }

    // let packagePremium = extractValue(text, regexPackage);
    // let igst = extractValue(text, regexSGST);
    // let cgst = ((companyName == "TATA" || companyName == "BAJAJ")
    //   ? extractValue(text, regexCGST) : "0") //extractValue(text, regexCGST); //if tata and bajaj
    // let totalPremium = extractValue(text, regexTotalPremium, companyName == "BAJAJ" ? 2 : 1); // for bajaj

    // // Output the extracted values
    // packagePremium = parseFloat(packagePremium.split(",").join(""));
    // igst = parseFloat(igst.split(",").join(""));
    // cgst = ((companyName == "TATA" || companyName == "BAJAJ")
    //   ? parseFloat(cgst.split(",").join("")) : 0); // if tata and bajaj
    // totalPremium = parseFloat(totalPremium.split(",").join(""))

    //if tata and bajaj
    // igst = igst + cgst

    if (packagePremium && igst && totalPremium) {
      // pdf generate single page  with acko premium
      let invoicePdfb64 = await exportInvoicePDF(data, { packagePremium, igst, totalPremium }, FormData);

      // merge 2 page pdf brilljust last pages
      let pageOne = await exportPdfPageOne({ ...data.proposal_body, ... { is_opt_gst: data.is_opt_gst } }, data.certificate_no, true);
      let pageTwo = await exportPdfPageTwo({ ...data.proposal_body, ... { is_opt_gst: data.is_opt_gst } }, data.certificate_no, true);

      let inputfile = await getBase64(file);

      if (companyName != "ACKO") {
        //decrypt pdf file
        let dispatchPdfDecryot = await dispatch(
          decryptPdfAction({
            data: {
              "pdfBase64": inputfile
            }
          })
        );
        if (dispatchPdfDecryot?.payload?.status === 1) {
          inputfile = dispatchPdfDecryot.payload.data;
        }
      }

      let pdfBase64Strings = []

      //merge all 3 pdf
      pdfBase64Strings = [
        inputfile,
        pageOne,
        // last2pagepdf
      ];

      if (!data.is_opt_gst) {
        pdfBase64Strings.push(invoicePdfb64)
      }

      if (!data?.is_hide_master_policy) {
        pdfBase64Strings.push(pageTwo)
      }

      const mergedPdf = await PDFDocument.create();

      for (const base64String of pdfBase64Strings) {
        const pdfBytes = base64ToUint8Array(base64String);
        const pdf = await PDFDocument.load(pdfBytes, { ignoreEncryption: true });
        const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
        copiedPages.forEach((page) => {
          mergedPdf.addPage(page);
        });
      }

      const mergedPdfBytes = await mergedPdf.save();
      var b64 = Buffer.from(mergedPdfBytes).toString('base64');

      const linkSource = `data:application/pdf;base64,${b64}`;
      const downloadLink = document.createElement("a");
      const fileName = "MERGE_" + data.certificate_no.replace('/', "_") + '.pdf';

      let payload = {
        "data": {
          "fileName": fileName,
          "chassisNumber": data?.proposal_body?.chassisNumber,
          "customerName": data?.first_name + " " + data?.last_name,
          "policyNumber": data.certificate_no,
          "email": data?.proposal_body?.emailId,
          "base64PdfData": b64,
        }
      }

      let body = {
        data: {
          "fileName": fileName,
          "policyNumber": data.certificate_no,
          "uploadedFileName": data?.merge_file_name,
          "base64PdfData": b64
        },
        token: userToken
      }



      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      closeModal()
      setLoading(false);
      dispatch(sendEmail(payload));
      dispatch(mergepdfAction(body))
      // if (resp?.payload?.status) {
      //   setmergepdfFlag((prev) => !prev)
      //   toast(resp?.payload?.msg || "Your data saved successfully", {
      //     position: "top-center",
      //     autoClose: 3000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "light",
      //   });
      // } else {
      //   toast.error(resp?.payload?.msg || "Something went wrong", {
      //     position: "top-center",
      //     autoClose: 3000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "light",
      //   });
      // }


    } else {
      closeModal()
      setLoading(false);
      toast.error("Invalid PDF !",
        {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      )
    }
    // })
    // .catch((error) => {
    //   setLoading(false);
    //   toast.error("Invalid PDF !",
    //     {
    //       position: "top-center",
    //       autoClose: 1500,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     }
    //   )
    // })
  }

  const extractText = async (data) => {

    let valid = validatePremiumDetails()
    try {
      // ✅ At least one file required
      if (!odFile && !tpFile) {
        setErrors({
          ...errors,
          tpFile: "Please provide at least one valid policy (OD or TP)",
        });
        return;
      }

      if (!FormData.gst || !FormData.totalPremium || !FormData.netPremium) {
        return
      }


      setLoading(true);
      setShowValidateBtn(true);
      closeModal();
      setErrors({})

      // ✅ Safe number parsing
      let packagePremium = Number(data?.netPremium) || 0;
      let igst = Number(data?.gst) || 0;
      let totalPremium = Number(data?.totalPremium) || 0;

      let companyName =
        data?.proposal_body?.companyName || "ACKO";

      // ✅ Validate numbers
      if (
        isNaN(packagePremium) ||
        isNaN(igst) ||
        isNaN(totalPremium)
      ) {
        throw new Error("Invalid premium data");
      }

      // ✅ Generate RSA PDFs
      let invoicePdfb64 = await exportInvoicePDF(
        data,
        { packagePremium, igst, totalPremium },
        FormData
      );

      let pageOne = await exportPdfPageOne(
        { ...data.proposal_body, is_opt_gst: data.is_opt_gst },
        data.certificate_no,
        true
      );

      let pageTwo = await exportPdfPageTwo(
        { ...data.proposal_body, is_opt_gst: data.is_opt_gst },
        data.certificate_no,
        true
      );

      // ✅ Convert files
      let odBase64 = odFile ? await getBase64(odFile) : null;
      let tpBase64 = tpFile ? await getBase64(tpFile) : null;

      // ✅ Decrypt safely
      if (companyName !== "ACKO") {
        if (odBase64) {
          let odDecrypt = await dispatch(
            decryptPdfAction({ data: { pdfBase64: odBase64 } })
          );
          if (odDecrypt?.payload?.status === 1) {
            odBase64 = odDecrypt.payload.data;
          }
        }

        if (tpBase64) {
          let tpDecrypt = await dispatch(
            decryptPdfAction({ data: { pdfBase64: tpBase64 } })
          );
          if (tpDecrypt?.payload?.status === 1) {
            tpBase64 = tpDecrypt.payload.data;
          }
        }
      }

      // ✅ Build merge array (NO NULLS)
      let pdfBase64Strings = [];

      if (odBase64) pdfBase64Strings.push(odBase64);
      if (tpBase64) pdfBase64Strings.push(tpBase64);

      // RSA Page 1 always
      pdfBase64Strings.push(pageOne);

      if (!data.is_opt_gst) {
        pdfBase64Strings.push(invoicePdfb64);
      }

      if (!data?.is_hide_master_policy) {
        pdfBase64Strings.push(pageTwo);
      }

      // ✅ Merge PDFs
      const mergedPdf = await PDFDocument.create();

      for (const base64String of pdfBase64Strings) {
        const pdfBytes = base64ToUint8Array(base64String);

        const pdf = await PDFDocument.load(pdfBytes, {
          ignoreEncryption: true,
        });

        const copiedPages = await mergedPdf.copyPages(
          pdf,
          pdf.getPageIndices()
        );

        copiedPages.forEach((page) => {
          mergedPdf.addPage(page);
        });
      }

      const mergedPdfBytes = await mergedPdf.save();
      const b64 = Buffer.from(mergedPdfBytes).toString("base64");

      // ✅ Download
      const fileName =
        "MERGE_" +
        data.certificate_no.replace("/", "_") +
        ".pdf";

      const linkSource = `data:application/pdf;base64,${b64}`;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();

      // ✅ API Payloads
      let payload = {
        data: {
          fileName,
          chassisNumber: data?.proposal_body?.chassisNumber,
          customerName:
            data?.first_name + " " + data?.last_name,
          policyNumber: data.certificate_no,
          email: data?.proposal_body?.emailId,
          base64PdfData: b64,
        },
      };

      let body = {
        data: {
          fileName,
          policyNumber: data.certificate_no,
          uploadedFileName: data?.merge_file_name,
          base64PdfData: b64,
        },
        token: userToken,
      };

      // ✅ Dispatch
      dispatch(sendEmail(payload));
      dispatch(mergepdfAction(body));

      // ✅ Reset
      setLoading(false);
      closeModal();
      setOdFile(null);
      setTpFile(null);

    } catch (error) {
      console.log(error);
      setLoading(false);
      closeModal();

      toast.error("Invalid PDF!", {
        position: "top-center",
        autoClose: 1500,
        theme: "light",
      });
    }
  };
  const handleDownloadMergeFile = async (filename, mobile) => {
    setLoading(true);
    let pdfUrl = `https://brilljust-merged-policy.s3.ap-south-1.amazonaws.com/${getclientMobileData}/${filename}`
    try {
      const response = await fetch(pdfUrl, { cache: 'no-store' }); // 'no-store' helps prevent caching
      if (!response.ok) {
        setLoading(false);
        throw new Error('Failed to fetch PDF');

      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'download.pdf';
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      setLoading(false);
    } catch (error) {
      console.error('Error downloading the PDF:', error);
      setLoading(false);
    }
  };





  const columns = [
    { id: "product", label: "Product" },
    { id: "policyNumber", label: "Policy Number" },
    { id: "insured", label: "Insured" },
    { id: "Date", label: "Date" },
    { id: "Amount", label: "Amount" },
    { id: "mobileNo", label: "Mobile No" },
    { id: "actions", label: "Actions" },
  ];

  const dataList = getTransactionList?.map((data) => ({

    product: (
      <div className="product_container">
        <p>{data.product_name}</p>
      </div>
    ),
    policyNumber: data.certificate_no,
    insured: data.first_name + " " + data.last_name,
    // Date: data.created_date,
    Date: moment?.utc(data?.proposal_body?.policyStartDate)?.tz("Asia/Kolkata").format("DD-MM-YYYY"),
    Amount: data.amount,
    mobileNo: data.mobile,
    actions: (

      <div className="tableBtn-container">
        <button
          className="downloadBtn-PolicyList"
          onClick={async (e) => {
            setLoading(true);
            await exportPDF({ ...data.proposal_body, ... { is_opt_gst: data.is_opt_gst, is_hide_master_policy: data.is_hide_master_policy } }, data.certificate_no)
            e.target.value = null;
            setLoading(false);
          }}
          data-tooltip="Download Policy"
        >
          <img src={download} alt="" srcSet="" />
        </button>

        <div className="custom-upload" id="Realtive_uploadbtn">
          {data.is_opt_gst ? (
            <>
              <input
                type="file"
                className="inputFile"
                data-tooltip="Upload File"
                id="inputFileMerge"
                onChange={(e) => {
                  extractTextIsOptGst(e, data);
                  e.target.value = null;
                }}
              />
              <label htmlFor="inputFileMerge" className="customUploadBtn">
                <button className="uploadBtn-PolicyList" data-tooltip="Upload File">
                  <img src={merge} alt="" srcSet="" />
                </button>
              </label>
            </>
          ) : (
            <>
              <button
                className="uploadBtn-PolicyList"
                onClick={(e) => openModal(data)}
                data-tooltip="Merge file"
              >
                <img src={merge} alt="" srcSet="" />
              </button>
            </>
          )}
        </div>

        <div className="custom-upload">
          <button
            className={data['merge_file_name'] ? "downloadBtn-PolicyList" : "disablebtn"}
            disabled={data['merge_file_name'] ? false : true}
            onClick={async (e) => {
              e.stopPropagation();

              handleDownloadMergeFile(data?.merge_file_name, data?.mobile);

            }}
            data-tooltip="Download Merged File"
          >
            <img src={mergeDownlaod} alt="" srcSet="" height={22} />
          </button>
        </div>
      </div>
    ),
  }));

  const HanldeFormData = (e, constantName) => {
    const { name, value, checked } = e?.target || {};
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="popUp-field-container">
          <h3>Enter Premium Details</h3>
          <div className="input-list-editVehicleDetails">
            <div className="input-container-form">
              <InputFields
                type="number"
                placeholder="Net Premium"
                name="netPremium"
                className="vehicleNumber"
                onChangeEvent={HanldeFormData}
                value={FormData.netPremium}
                errState={errors?.netPremium ? true : false}
                errMsg={errors?.netPremium}
                errClassName="input-err"
              />
              <InputFields
                type="number"
                placeholder="GST"
                name="gst"
                className="vehicleNumber"
                onChangeEvent={HanldeFormData}
                value={FormData.gst}
                errState={errors?.gst ? true : false}
                errMsg={errors?.gst}
                errClassName="input-err"
              />
            </div>
            <div className="input-container-form">
              <InputFields
                type="number"
                placeholder="Total Premium"
                name="totalPremium"
                className="vehicleNumber"
                onChangeEvent={HanldeFormData}
                value={FormData.totalPremium}
                errState={errors?.totalPremium ? true : false}
                errMsg={errors?.totalPremium}
                errClassName="input-err"
              />
              <div></div>

            </div>
            {getclientMobileData == "7042192733" &&

              <div className="uploadWrapper">
                {/* OD Policy */}
                <div className="uploadBox">
                  <label className="uploadLabel">OD Policy Upload</label>
                  <input
                    type="file"
                    className="fileUploadInput "
                    onChange={(e) => setOdFile(e.target.files[0])}
                  />
                </div>

                {/* TP Policy */}
                <div className="uploadBox">
                  <label className="uploadLabel">TP Policy Upload</label>
                  <input
                    type="file"
                    className="fileUploadInput "
                    onChange={(e) => setTpFile(e.target.files[0])}
                  />
                </div>


              </div>


            }
            {(!tpFile && !odFile) ? <div className="err-msg">{errors?.tpFile}</div> : ""}




            <div className="btngrp-container">
              <Button
                text="Back"
                className="secondry_btn btn-vehicledetails "
                event={closeModal}
              />


              {
                ShowValidateBtn ? (
                  <div className="custom-upload">
                    <button className="button btn-vehicledetails " onClick={validatePremiumDetails} >
                      Save
                    </button>
                  </div>
                ) : (
                  getclientMobileData == "7042192733" ? <div className="custom-upload" >

                    <label htmlFor="inputFileMerge" className="customUploadBtn">
                      <button className="button btn-vehicledetails " onClick={() => extractText({ ...TransactionData, ...FormData })}
                      >
                        Save
                      </button>
                    </label>
                  </div> :
                    <div className="custom-upload">
                      <input type="file" className="inputFile" style={{ border: "2px solid red" }} id="inputFileMergeStander" onChange={(e) => {
                        extractTextIsOptGst(e, { ...TransactionData, ...FormData })
                        e.target.value = null
                      }} />
                      <label htmlFor="inputFileMerge" className="customUploadBtn">
                        <button className="button btn-vehicledetails ">
                          Save
                        </button>
                      </label>
                    </div>




                )
              }
            </div>
          </div>
        </div>
      </Modal>

      {loading ? <Loader /> : null}

      <DataTable columns={columns} data={dataList} getTransactionListTotalCount={getTransactionListTotalCount} page={page} setPage={setPage} filterText={filterText} setFilterText={setFilterText} searachQuery={searachQuery} setSerachQuery={setSerachQuery} timeoutRef={timeoutRef} setRowsPerPage={setRowsPerPage} rowsPerPage={rowsPerPage} newLoder={newLoder} setNewLoadi={setNewLoadi} setSearchQueryFlag={setSearchQueryFlag} />
      <ToastContainer />
    </>
  );
};

export default NoPoliciesFound;
